import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import CloseIcon from '@material-ui/icons/Close';
import { propShape, propFunc, propStr, } from '../../../../helpers/custom-prop-types';
import { compose } from '../../../../helpers/recompose';
import ModalHoc from '../../../Ui/Modal/ModalHoc';
import SlideSearchShareStatusTab from '../../../Ui/SlideSearch/ShareStatusTab';
/**
 * 共有状況を表示するモーダル
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchHeaderShareModal = (props) => {
    const { hideModal, modalState, receive, share } = props;
    return (_jsxs("div", Object.assign({ className: `slide_search_header_share_modal fade_modal animated-opacity ${modalState}` }, { children: [_jsx("div", { className: 'bg', onClick: hideModal, role: 'presentation' }), _jsxs("div", Object.assign({ className: 'modal_box' }, { children: [_jsxs("div", Object.assign({ className: 'modal_header' }, { children: [_jsx("div", Object.assign({ className: 'header_text' }, { children: "\u5171\u6709\u72B6\u6CC1" })), _jsx("button", Object.assign({ className: 'header_close', onClick: hideModal, type: 'button' }, { children: _jsx(CloseIcon, { className: 'close_svg' }) }))] })), _jsx("div", Object.assign({ className: 'modal_body' }, { children: _jsx(SlideSearchShareStatusTab, { className: 'body_tab', receive: receive, share: share }) })), _jsx("div", { className: 'modal_spacer' })] }))] })));
};
SlideSearchHeaderShareModal.propTypes = {
    hideModal: propFunc().isRequired,
    modalState: propStr().isRequired,
    receive: propShape().isRequired,
    share: propShape().isRequired,
};
const enhance = compose(ModalHoc);
export default enhance(SlideSearchHeaderShareModal);
